import { CustomFieldTemplateApi } from "go-segment/services/types";

export interface ExportInvoicePdfConfig {
	printCustomFields?: boolean;
	customFields?: CustomFieldTemplateApi[];
	duplicate?: boolean;
	duplicateDate?: string;
	group?: boolean;
	groupName?: string;
	company?: string;
	taxIdNo?: string;
	organization?: string;
}

export enum InvoicePdfColumn {
	POSITION = "position",
	NAME = "name",
	PKWIU = "pkwiu",
	UNIT = "unit",
	QUANTITY = "quantity",
	UNIT_PRICE = "unit_price",
	TOTAL_PRICE = "total_price",
	TAX = "tax",
}

export enum InvoiceSummaryPdfColumn {
	EMPTY = "empty",
	TAX = "tax",
	TOTAL_PRICE_NET = "total_price_net",
	TOTAL_PRICE_GROSS = "total_price_gross",
	TAX_PRICE = "tax_price",
}

export enum InvoicePaymentsPdfColumn {
	PAID = "paid",
	PAYMENT_METHOD = "payment_method",
	DATE = "date",
	PRICE = "price",
}
